import { ITypograhyProps, Typography } from 'components/common'
import { CollectiveProposal, CollectiveProposalStatus } from 'graphql/generated'
import { formatTimeLabel } from 'lib/datetime'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

type TProposal = Pick<CollectiveProposal, 'startTime' | 'endTime' | 'status'>

interface IProps {
  proposal: TProposal
  outlined?: boolean
  color?: ITypograhyProps['color']
  fontWeight?: ITypograhyProps['fontWeight']
  compact?: boolean
}

function ProposalTimingInfo({
  proposal,
  outlined = false,
  color,
  fontWeight,
  compact = false
}: IProps) {
  const hasStarted = moment(proposal.startTime).isBefore(moment())

  const hasEnded = ![
    CollectiveProposalStatus.PENDING,
    CollectiveProposalStatus.ACTIVE
  ].includes(proposal.status)
  const hasEndedEarly = moment(proposal.endTime).isAfter(moment()) && hasEnded

  const [secondsLeft, setSecondsLeft] = useState(
    (moment(hasStarted ? proposal.endTime : proposal.startTime)
      .toDate()
      .getTime() -
      moment().toDate().getTime()) /
      1000
  )

  useEffect(() => {
    if (secondsLeft <= 0) {
      return
    }

    const timer = setInterval(() => {
      setSecondsLeft(x => x - 1)
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [secondsLeft])

  return (
    <div>
      {!hasStarted && (
        <Typography
          color={color}
          fontWeight={fontWeight ? fontWeight : 'light'}
        >
          Voting will begin in {formatTimeLabel(secondsLeft, compact, compact)}
        </Typography>
      )}

      {hasStarted && !hasEnded && !hasEndedEarly && (
        <div
          className={twMerge(
            'rounded-3xl',
            outlined && 'border border-solid border-gray-300 p-2'
          )}
        >
          <Typography
            color={color}
            fontWeight={fontWeight ? fontWeight : 'light'}
          >
            {formatTimeLabel(secondsLeft, compact, compact)}
            {` left`}
          </Typography>
        </div>
      )}

      {hasStarted && hasEnded && (
        <Typography
          color={color}
          fontWeight={fontWeight ? fontWeight : 'light'}
        >
          {hasEndedEarly
            ? `Voting ended (proposal ended early)`
            : `Voting ended`}
        </Typography>
      )}
    </div>
  )
}

export default ProposalTimingInfo
